import { render, staticRenderFns } from "./ForgotPassMain.vue?vue&type=template&id=d57d8c72&"
import script from "./ForgotPassMain.vue?vue&type=script&lang=js&"
export * from "./ForgotPassMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d57d8c72')) {
      api.createRecord('d57d8c72', component.options)
    } else {
      api.reload('d57d8c72', component.options)
    }
    module.hot.accept("./ForgotPassMain.vue?vue&type=template&id=d57d8c72&", function () {
      api.rerender('d57d8c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user_login/ForgotPassMain.vue"
export default component.exports